import React from 'react';
import autobind from '../../../js-helpers/autobind'; // eslint-disable-line no-unused-vars
import PropTypes from 'prop-types';

export default class Radio extends React.Component {
  @autobind
  onChange(e) {
    if (this.props.onChange) {
      this.props.onChange(e);
    }
  }

  render() {
    const id = this.props.value.replace(/\s+/, '-');

    return (
      <div className="radio-container">
        <input
          type="radio"
          id={id}
          value={this.props.value}
          name={this.props.name}
          onChange={this.onChange}
          checked={this.props.checked}
        />
        <div className="radio-container__check"></div>
        {
          this.props.label ?
          <label htmlFor={id}>{this.props.label}</label> : null
        }
      </div>
    );
  }
}

Radio.propTypes = {
  onChange: PropTypes.any,
};
